import { render, staticRenderFns } from "./ForbiddenGoodsFilter.vue?vue&type=template&id=45560e3c&scoped=true"
import script from "./ForbiddenGoodsFilter.vue?vue&type=script&lang=js"
export * from "./ForbiddenGoodsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45560e3c",
  null
  
)

export default component.exports